import { render, staticRenderFns } from "./LittleGateOtherDamages.vue?vue&type=template&id=18246a2a&scoped=true"
import script from "./LittleGateOtherDamages.vue?vue&type=script&lang=ts"
export * from "./LittleGateOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18246a2a",
  null
  
)

export default component.exports